import { LegacyBillcheckState } from './legacyBillCheck';
import { BillcheckV3State } from './billCheckV3';
import { DepositState } from './deposit';
import { InsuranceState } from './productBenefits';
import { StorageboxState } from './storagebox';
import { TenantProtectionState } from './tenantProtection';
import { TurtleboxState } from './turtleBoxState';
import { InsurancePackageState } from './insurance';

export interface ProductsStatusResponse {
  billcheck?: LegacyBillcheckState;
  billcheckV3?: BillcheckV3State;
  deposit?: DepositState;
  profileBenefits?: InsuranceState;
  lagerbox?: StorageboxState;
  turtlebox?: TurtleboxState;
  tenantProtection?: TenantProtectionState;
  insurancePackage?: InsurancePackageState;
}

export enum ProductsStatusKey {
  Billcheck = 'billcheck',
  BillcheckV3 = 'billcheckV3',
  Deposit = 'deposit',
  ProfileBenefits = 'profileBenefits',
  Lagerbox = 'lagerbox',
  Turtlebox = 'turtlebox',
  TenantProtection = 'tenantProtection',
  insurancePackage = 'insurancePackage',
}

export interface ProductsStatus extends ProductsStatusResponse {
  calendar?: CalendarRes;
  schufa?: SolvencyRes;
}

export interface SolvencyRes {
  expirationDate?: string;
  verificationCode?: string;
}

export type CalendarRes = {
  appointmentId?: string;
  startDate?: string;
  startTime?: string;
  endDate?: string;
  endTime?: string;
  pictureUrl?: string | null;
  exposeId?: number | null;
  title?: string | null;
  status?: string | null;
  address?: string | null;
  phone?: string | null;
  contactPerson?: string | null;
  exposeBuyPrice?: number | null;
  exposeBaseRentPrice?: number | null;
  version?: number | null;
  allInviteEventsSeen?: boolean | null;
}[];
